//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  mounted() {},
  data() {
    return {
      h: 0
    };
  },
  methods: {
    certificateApproval() {
      let t = this;
      t.$router.push("/certificateApproval");
    },
    analysis() {
      let t = this;
      t.$router.push("/analysis");
    },
    personalAnalysis() {
      let t = this;
      t.$router.push("personalAnalysis");
    },
    certificateFind() {
      let t = this;
      t.$router.push("/certificateFind");
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/index/index.vue